/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Business } from './Business';
import {
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
    BusinessToJSONTyped,
} from './Business';

/**
 * 
 * @export
 * @interface GetBusinessesChildrenResponse
 */
export interface GetBusinessesChildrenResponse {
    /**
     * 
     * @type {Array<Business>}
     * @memberof GetBusinessesChildrenResponse
     */
    children: Array<Business>;
}

/**
 * Check if a given object implements the GetBusinessesChildrenResponse interface.
 */
export function instanceOfGetBusinessesChildrenResponse(value: object): value is GetBusinessesChildrenResponse {
    if (!('children' in value) || value['children'] === undefined) return false;
    return true;
}

export function GetBusinessesChildrenResponseFromJSON(json: any): GetBusinessesChildrenResponse {
    return GetBusinessesChildrenResponseFromJSONTyped(json, false);
}

export function GetBusinessesChildrenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBusinessesChildrenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'children': ((json['children'] as Array<any>).map(BusinessFromJSON)),
    };
}

export function GetBusinessesChildrenResponseToJSON(json: any): GetBusinessesChildrenResponse {
    return GetBusinessesChildrenResponseToJSONTyped(json, false);
}

export function GetBusinessesChildrenResponseToJSONTyped(value?: GetBusinessesChildrenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'children': ((value['children'] as Array<any>).map(BusinessToJSON)),
    };
}

